"use client";

import TestRunner from "@/components/teste/TestRunner";
import { burnoutConfig, type BurnoutCategory } from "@/data/tests/burnout";
import type { PublicTherapistSummary } from "@/actions/getTherapists";
import { captureBurnoutLead, submitBurnoutTest } from "./actions";

/**
 * The client boundary for the burnout test.
 *
 * The config carries functions (`categorize`, `subjectTemplate`) and the
 * Zenyra prefill is one too, so none of it can be handed to `TestRunner` as a
 * prop from the server page. Importing it here keeps it on the client side of
 * the boundary; the page passes only the therapist list, which serialises.
 */
export default function BurnoutRunner({
  therapists,
}: {
  therapists: PublicTherapistSummary[];
}) {
  return (
    <TestRunner<BurnoutCategory>
      config={burnoutConfig}
      submit={submitBurnoutTest}
      capture={captureBurnoutLead}
      therapists={therapists}
      urgentCategories={["severe"]}
      zenyra={{
        topic: "burnout",
        prefill: (score, category) => {
          const label =
            burnoutConfig.bands.find((b) => b.category === category)?.label ?? category;
          return `Am facut testul de burnout pe Mindtale si scorul meu este ${score}/100 (${label}). Vreau sa povestim despre ce inseamna pentru mine si cum pot continua.`;
        },
      }}
      emailCopy={{
        headline: "Vreau să învăț mai multe despre burnout",
        body: "Câteva resurse scurte despre burnout, susținute de cercetare, plus pași concreți. Fără spam, te dezabonezi oricând.",
        submitLabel: "Vreau emailurile",
      }}
    />
  );
}
